(function () {
  if (typeof window.ushareApplyI18n === "function") window.ushareApplyI18n();
  var mount = document.querySelector("[data-ushare-search]");
  if (!mount) return;
  var root = document;

  var form = root.querySelector("[data-search-form]");
  var deptInput = root.querySelector("[data-dept-input]");
  var diseaseInput = root.querySelector("[data-disease-input]");
  var specCards = Array.prototype.slice.call(root.querySelectorAll("[data-spec-grid] .ushare-sr-card"));
  var specCombo = root.querySelector('[data-combo="specialty"]');
  var disCombo = root.querySelector('[data-combo="disease"]');
  var specList = root.querySelector("[data-spec-list]");
  var disList = root.querySelector("[data-disease-list]");
  var titleEl = root.querySelector("[data-results-title]");
  var specGrid = root.querySelector("[data-spec-grid]");
  var diseaseGrid = root.querySelector("[data-disease-grid]");
  var emptyEl = root.querySelector("[data-disease-empty]");
  var actions = root.querySelector("[data-disease-actions]");
  var actionText = root.querySelector("[data-action-text]");
  var actionHospitals = root.querySelector("[data-action-hospitals]");
  var actionQuote = root.querySelector("[data-action-quote]");
  var diseases = window.USHARE_SEARCH_DISEASES || [];

  function loadRemainingDiseases() {
    var pagination = window.USHARE_DISEASES_PAGINATION;
    if (!pagination || pagination.pageCount <= 1 || typeof window.fetch !== "function") {
      return Promise.resolve();
    }
    var baseUrl = new URL(window.location.href);
    var pages = [];
    for (var page = 1; page <= pagination.pageCount; page++) {
      if (page === pagination.currentPage) continue;
      var pageUrl = new URL(baseUrl.toString());
      pageUrl.searchParams.set("page", String(page));
      pages.push(
        window.fetch(pageUrl.toString(), { credentials: "same-origin" })
          .then(function (response) {
            if (!response.ok) throw new Error("Disease page request failed");
            return response.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, "text/html");
            var node = doc.querySelector("script[data-ushare-disease-page]");
            if (!node) return [];
            try {
              return JSON.parse(node.textContent || "[]");
            } catch (err) {
              return [];
            }
          })
      );
    }
    return Promise.all(pages).then(function (results) {
      results.forEach(function (list) {
        if (Array.isArray(list)) diseases = diseases.concat(list);
      });
    }).catch(function () {
      // The first page remains usable if a later page cannot be fetched.
    });
  }

  var hospitalsUrl = mount.getAttribute("data-hospitals-url") || (window.ushareUrl || String)("/hospitals");
  var quoteUrl = mount.getAttribute("data-quote-url") || (window.ushareUrl || String)("/free-quote");
  var selectedDept = "";
  var selectedDisease = "";
  var copy = {};
  var copyNode = root.querySelector("[data-search-copy]");
  if (copyNode) {
    try {
      copy = JSON.parse(copyNode.textContent);
    } catch (err) {
      copy = {};
    }
  }

  var DEPT_ALIASES = {
    cardiology: "cardiology_cardiothoracic",
    orthopedics: "musculoskeletal_orthopedics_spine",
    orthopaedics: "musculoskeletal_orthopedics_spine",
    neurology: "neurology_neurosurgery",
    dentistry: "dentistry_oral_maxillofacial",
    endocrinology: "endocrinology_metabolism",
    ent: "ent_otolaryngology",
    gastroenterology: "gastroenterology_hepatology",
    rheumatology: "immune_rheumatology",
    pediatrics: "pediatrics_congenital_heart",
    plastic: "plastic_reconstructive",
    reproductive: "reproductive_obgyn_andrology",
    obgyn: "reproductive_obgyn_andrology",
    respiratory: "respiratory_thoracic"
  };

  function decodeText(value) {
    var box = document.createElement("textarea");
    box.innerHTML = value || "";
    return box.value;
  }

  function specialties() {
    return specCards.map(function (card) {
      return {
        slug: card.getAttribute("data-slug"),
        title: decodeText(card.getAttribute("data-title")),
        text: decodeText(card.getAttribute("data-text")),
        popular: card.hasAttribute("data-popular"),
        image: (card.querySelector("img") || {}).src || ""
      };
    });
  }

  function findSpec(slug) {
    var list = specialties();
    for (var i = 0; i < list.length; i++) {
      if (list[i].slug === slug) return list[i];
    }
    return null;
  }

  function resolveDept(value) {
    if (!value) return "";
    var raw = String(value).trim();
    if (findSpec(raw)) return raw;
    var alias = DEPT_ALIASES[raw.toLowerCase()];
    if (alias && findSpec(alias)) return alias;
    return slugFromName(raw);
  }

  function slugify(name) {
    return String(name || "")
      .toLowerCase()
      .trim()
      .replace(/&/g, " and ")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function setLabel(combo, text, filled) {
    var label = combo.querySelector("[data-combo-label]");
    var btn = combo.querySelector("[data-combo-toggle]");
    label.textContent = text;
    btn.classList.toggle("is-filled", !!filled);
  }

  function closeAll(except) {
    root.querySelectorAll(".ushare-sr-combo").forEach(function (el) {
      if (el !== except) el.classList.remove("is-open");
    });
  }

  function setDiseaseEnabled(on) {
    disCombo.classList.toggle("is-disabled", !on);
    var btn = disCombo.querySelector("[data-combo-toggle]");
    if (btn) btn.disabled = !on;
  }

  function optionHtml(item, active, kind) {
    var attr = kind === "disease" ? ' data-pick-disease="' + encodeURIComponent(item.title) + '" data-dept="' + item.slug + '"' : ' data-pick-spec="' + item.slug + '"';
    return (
      '<button class="ushare-sr-option' + (active ? " is-active" : "") + '" type="button"' + attr + ">" +
        "<strong>" + item.title + "</strong>" +
        (item.text ? "<small>" + item.text + "</small>" : "") +
      "</button>"
    );
  }

  function renderSpecs(query) {
    var q = (query || "").toLowerCase().trim();
    var items = specialties().filter(function (item) {
      if (!q) return true;
      return (item.title + " " + item.text).toLowerCase().indexOf(q) !== -1;
    });
    var popular = items.filter(function (item) { return item.popular; });
    var rest = items.filter(function (item) { return !item.popular; });
    rest.sort(function (a, b) { return a.title.localeCompare(b.title); });
    if (!items.length) {
      specList.innerHTML = '<p class="ushare-sr-panel__empty">' + (copy.empty || "") + "</p>";
      return;
    }
    var html = "";
    if (popular.length) {
      html += '<p class="ushare-sr-panel__label">' + (copy.popular || "") + "</p>";
      popular.forEach(function (item) { html += optionHtml(item, selectedDept === item.slug, "spec"); });
    }
    if (rest.length) {
      html += '<p class="ushare-sr-panel__label">' + (copy.more || "") + "</p>";
      rest.forEach(function (item) { html += optionHtml(item, selectedDept === item.slug, "spec"); });
    }
    specList.innerHTML = html;
  }

  function deptDiseases() {
    return diseases.filter(function (item) {
      return !selectedDept || item.d === selectedDept;
    });
  }

  function renderDiseases(query) {
    var q = (query || "").toLowerCase().trim();
    var list = deptDiseases().filter(function (item) {
      if (!q) return true;
      return item.n.toLowerCase().indexOf(q) !== -1 || (item.nEn && item.nEn.toLowerCase().indexOf(q) !== -1);
    });
    if (!q && !selectedDept) list = list.slice(0, 80);
    if (!list.length) {
      disList.innerHTML = '<p class="ushare-sr-panel__empty">' + (copy.empty || "") + "</p>";
      return;
    }
    disList.innerHTML = list.map(function (item) {
      return optionHtml(
        { title: item.n, slug: item.d, text: "" },
        selectedDisease === item.n,
        "disease"
      );
    }).join("");
  }

  function diseaseImageUrl(item, fallback) {
    if (!item || !item.i) return fallback || "";
    var sample = mount.getAttribute("data-asset-sample") || "";
    var name = mount.getAttribute("data-asset-sample-name") || "ushare-search-oncology.webp";
    if (!sample || sample.indexOf(name) === -1) return fallback || "";
    return sample.split(name).join("ushare-sr-d-" + item.i + ".webp");
  }

  function parkActions() {
    if (!actions || !specGrid || !specGrid.parentNode) return;
    if (actions.parentNode !== specGrid.parentNode) {
      specGrid.parentNode.insertBefore(actions, specGrid);
    }
  }

  function gridColumnCount(grid) {
    var value = window.getComputedStyle(grid).gridTemplateColumns;
    if (!value || value === "none") return 1;
    return value.split(" ").filter(Boolean).length || 1;
  }

  function placeActions() {
    if (!actions) return;
    if (!selectedDept || !selectedDisease || !diseaseGrid || diseaseGrid.hidden) {
      parkActions();
      actions.hidden = true;
      return;
    }
    var card = diseaseGrid.querySelector(
      '[data-disease-name="' + encodeURIComponent(selectedDisease) + '"]'
    );
    if (!card) {
      parkActions();
      actions.hidden = true;
      return;
    }
    var cards = Array.prototype.slice.call(diseaseGrid.querySelectorAll(".ushare-sr-card"));
    var index = cards.indexOf(card);
    var cols = gridColumnCount(diseaseGrid);
    var rowStart = Math.floor(Math.max(index, 0) / cols) * cols;
    var anchor = cards[rowStart] || card;
    diseaseGrid.insertBefore(actions, anchor);
    actions.hidden = false;
  }

  function renderDiseaseCards() {
    parkActions();
    var spec = findSpec(selectedDept);
    var list = diseases.filter(function (item) { return item.d === selectedDept; });
    list.sort(function (a, b) { return a.n.localeCompare(b.n); });
    if (!list.length) {
      diseaseGrid.innerHTML = "";
      return;
    }
    var fallback = spec ? spec.image : "";
    diseaseGrid.innerHTML = list.map(function (item) {
      var active = selectedDisease === item.n ? " is-active" : "";
      var image = diseaseImageUrl(item, fallback);
      return (
        '<article class="ushare-sr-card ushare-sr-card--disease' + active + '" data-disease-name="' + encodeURIComponent(item.n) + '">' +
          '<div class="ushare-sr-card__photo">' +
            (image ? '<img src="' + image + '" alt="' + item.n.replace(/"/g, "&quot;") + '" width="640" height="420" loading="lazy">' : "") +
          "</div>" +
          '<div class="ushare-sr-card__body"><h3>' + item.n + "</h3></div>" +
        "</article>"
      );
    }).join("");
  }

  function updateActions() {
    if (!actions) return;
    if (!selectedDept || !selectedDisease) {
      parkActions();
      actions.hidden = true;
      return;
    }
    if (actionText) {
      actionText.textContent = (copy.diseaseHelp || "").replace("%name%", selectedDisease);
    }
    if (actionHospitals) {
      actionHospitals.href = hospitalsUrl + "?dept=" + encodeURIComponent(selectedDept);
    }
    if (actionQuote) {
      actionQuote.href = quoteUrl + "?procedure=" + encodeURIComponent(selectedDisease);
    }
    placeActions();
  }

  function showResults() {
    var spec = findSpec(selectedDept);
    if (!selectedDept) {
      if (titleEl) titleEl.textContent = copy.gridTitle || "";
      if (specGrid) specGrid.hidden = false;
      if (diseaseGrid) diseaseGrid.hidden = true;
      if (emptyEl) emptyEl.hidden = true;
      updateActions();
      return;
    }
    if (titleEl) titleEl.textContent = spec ? spec.title : selectedDept;
    if (specGrid) specGrid.hidden = true;
    renderDiseaseCards();
    var hasCards = diseaseGrid && diseaseGrid.children.length;
    if (diseaseGrid) diseaseGrid.hidden = !hasCards;
    if (emptyEl) emptyEl.hidden = !!hasCards;
    updateActions();
  }

  function syncUrl() {
    var url = new URL(window.location.href);
    if (selectedDept) url.searchParams.set("dept", selectedDept);
    else url.searchParams.delete("dept");
    if (selectedDisease) url.searchParams.set("disease", slugify(selectedDisease));
    else url.searchParams.delete("disease");
    url.searchParams.delete("department");
    url.searchParams.delete("q");
    history.replaceState({}, "", url);
  }

  function applyDept(slug, opts) {
    opts = opts || {};
    selectedDept = slug || "";
    if (deptInput) deptInput.value = selectedDept;
    var spec = findSpec(selectedDept);
    if (spec) setLabel(specCombo, spec.title, true);
    else setLabel(specCombo, copy.specPlaceholder || "", false);
    setDiseaseEnabled(!!selectedDept);
    if (!selectedDept) {
      selectedDisease = "";
      if (diseaseInput) diseaseInput.value = "";
      setLabel(disCombo, copy.diseasePlaceholder || "", false);
    }
    renderSpecs(specCombo.querySelector("[data-combo-filter]").value);
    renderDiseases(disCombo.querySelector("[data-combo-filter]").value);
    showResults();
    if (opts.sync !== false) syncUrl();
    if (opts.scroll && selectedDept) {
      root.querySelector("#ushare-sr-results").scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }

  function applyDisease(name, dept) {
    if (dept && dept !== selectedDept) {
      selectedDisease = "";
      applyDept(dept, { sync: false });
    }
    if (selectedDisease === name) {
      selectedDisease = "";
      if (diseaseInput) diseaseInput.value = "";
      setLabel(disCombo, copy.diseasePlaceholder || "", false);
    } else {
      selectedDisease = name || "";
      if (diseaseInput) diseaseInput.value = selectedDisease;
      setLabel(disCombo, selectedDisease, true);
    }
    renderDiseases(disCombo.querySelector("[data-combo-filter]").value);
    showResults();
    syncUrl();
    if (selectedDisease && actions && !actions.hidden) {
      actions.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  }

  function slugFromName(name) {
    if (!name) return "";
    var n = name.toLowerCase().trim();
    var match = specialties().filter(function (item) {
      return item.title.toLowerCase() === n || item.slug.replace(/_/g, " ") === n;
    })[0];
    if (match) return match.slug;
    if (/pediatric/.test(n)) return "pediatrics_congenital_heart";
    return "";
  }

  function diseaseFromParam(value) {
    if (!value) return "";
    var raw = decodeURIComponent(String(value)).replace(/-/g, " ").toLowerCase();
    var list = diseases.filter(function (item) {
      if (selectedDept && item.d !== selectedDept) return false;
      return item.n.toLowerCase() === raw || slugify(item.n) === String(value).toLowerCase();
    });
    return list.length ? list[0].n : "";
  }

  specCombo.addEventListener("click", function (event) {
    var pick = event.target.closest("[data-pick-spec]");
    if (!pick) return;
    selectedDisease = "";
    if (diseaseInput) diseaseInput.value = "";
    setLabel(disCombo, copy.diseasePlaceholder || "", false);
    applyDept(pick.getAttribute("data-pick-spec"), { scroll: true });
    specCombo.classList.remove("is-open");
  });

  disCombo.addEventListener("click", function (event) {
    var pick = event.target.closest("[data-pick-disease]");
    if (!pick) return;
    applyDisease(decodeURIComponent(pick.getAttribute("data-pick-disease")), pick.getAttribute("data-dept"));
    disCombo.classList.remove("is-open");
  });

  root.querySelectorAll("[data-combo-toggle]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var combo = btn.closest(".ushare-sr-combo");
      if (combo.classList.contains("is-disabled")) return;
      var open = !combo.classList.contains("is-open");
      closeAll();
      combo.classList.toggle("is-open", open);
      if (open) {
        if (combo.getAttribute("data-combo") === "specialty") renderSpecs("");
        else renderDiseases("");
        var input = combo.querySelector("[data-combo-filter]");
        if (input) {
          input.value = "";
          input.focus();
        }
      }
    });
  });

  specCombo.querySelector("[data-combo-filter]").addEventListener("input", function (event) {
    renderSpecs(event.target.value);
  });
  disCombo.querySelector("[data-combo-filter]").addEventListener("input", function (event) {
    renderDiseases(event.target.value);
  });

  document.addEventListener("click", function (event) {
    if (!root.contains(event.target)) closeAll();
    else if (!event.target.closest(".ushare-sr-combo")) closeAll();
  });

  var resizeTimer = 0;
  window.addEventListener("resize", function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(placeActions, 120);
  });

  specCards.forEach(function (card) {
    card.addEventListener("click", function () {
      selectedDisease = "";
      if (diseaseInput) diseaseInput.value = "";
      setLabel(disCombo, copy.diseasePlaceholder || "", false);
      applyDept(card.getAttribute("data-slug"), { scroll: true });
    });
  });

  diseaseGrid.addEventListener("click", function (event) {
    var card = event.target.closest("[data-disease-name]");
    if (!card) return;
    applyDisease(decodeURIComponent(card.getAttribute("data-disease-name")), selectedDept);
  });

  form.addEventListener("submit", function (event) {
    event.preventDefault();
    if (!selectedDept) {
      root.querySelector("#ushare-sr-results").scrollIntoView({ behavior: "smooth", block: "start" });
      return;
    }
    var dest = hospitalsUrl + "?dept=" + encodeURIComponent(selectedDept);
    if (selectedDisease) dest += "&disease=" + encodeURIComponent(slugify(selectedDisease));
    window.location.href = dest;
  });

  var params = new URLSearchParams(window.location.search);
  var initialDept = resolveDept(params.get("dept") || params.get("department") || "");
  loadRemainingDiseases().then(function () {
    renderSpecs("");
    renderDiseases("");
    setDiseaseEnabled(false);
    if (initialDept) {
      applyDept(initialDept, { sync: false, scroll: false });
      var initialDisease = diseaseFromParam(params.get("disease") || "");
      if (initialDisease) applyDisease(initialDisease, initialDept);
      else syncUrl();
    } else {
      showResults();
    }
  });
})();
